<!--
 * @Description: 
 * @Date: 2021-02-05 23:41:15
-->
<template>
  <div class="living-end">
    <img :src="livingStore.detail.videoPicUrl" />
    <div>
      <!-- <img src="@/static/img/notBegin.jpg" /> -->
      <p>直播已结束</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LivingEnd',
  inject: ['livingStore'],
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
$--height: 5.63rem;
$--width: 10rem;
.living-end {
  position: relative;
  width: $--width;
  height: $--height;
  img {
    width: $--width;
    height: $--height;
  }
  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: $--width;
    height: $--height;
    z-index: 10;
    background: #000;
    opacity: 0.8;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    img {
      width: 0.75rem;
      height: 0.75rem;
      margin: 2.12rem auto 0.21rem;
    }
    p {
      font-size: 0.43rem;
      color: #fff;
      line-height: 0.43rem;
    }
  }
}
</style>
